import { createClient } from "@sanity/client";

export const SanityConfig = createClient({
    projectId: "btc6jvlk",
    dataset: "production",
    useCdn: true,
    apiVersion: "2023-05-03",
  });